// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";
// import * as crud from "../CatalogClients/operations"; // Validation schema
const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  phone: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  address: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  born: Yup.date().required("Field is neccesary"),
  email: Yup.string()
    .email()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  bank_routing: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  bank_account: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
});
/* const AVAILABLE_LOCATIONS = ["--null--", "Arizona", "Texas"]; */
export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
}) {
  const [isSubmitting, setSubmitting] = useState(false)

  // const [AVAILABLE_CLIENTS, setClients] = useState([
  //   { name: "--null--", uid: "--null--" },
  // ]);

  // useEffect(() => crud.getClients(setClients), []);
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={client}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          update({ ...client, ...values })
          .then(() => setSubmitting(false))
          .end((err) => {
            setSubmitting(false)
          })
        }}
      >
        {({ handleSubmit, handleChange, errors }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  <div className="col-lg-4">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="First Name"
                      label="First Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Last Name */}
                  <div className="col-lg-4">
                    <Field
                      name="phone"
                      component={Input}
                      placeholder="Phone"
                      label="Phone"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Login */}
                  <div className="col-lg-4">
                    <Field
                      type="text"
                      name="address"
                      component={Input}
                      placeholder="address"
                      label="address"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                {/* Email */}
                <div className="form-group row">
                  <div className="col-lg-4">
                    <Field
                      type="email"
                      name="email"
                      component={Input}
                      placeholder="Email"
                      label="Email"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Date of birth */}
                  <div className="col-lg-4">
                    <Field
                      type="text"
                      name="born"
                      component={Input}
                      placeholder="born"
                      label="born"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* IP Address */}
                  <div className="col-lg-4">
                    <Field
                      type="text"
                      name="bank_account"
                      component={Input}
                      placeholder="Bank Account"
                      label="Bank Account"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Bank routing*/}
                  <div className="col-lg-4">
                    <Field
                      type="text"
                      name="bank_routing"
                      component={Input}
                      placeholder="Bank Routing"
                      label="Bank Routing"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                  onClick={() => {
                    setSubmitting(true)
                    handleSubmit()
                  }}
                  disabled={isSubmitting}
                  className="btn btn-primary btn-elevate"
                >
                  {isSubmitting ?
                    <div className="d-flex align-items-center">
                      <div className="mr-2">Loading...</div>
                      <div className="spinner spinner-white mr-10"></div>
                    </div> : "Save"}
                </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg">
        <Modal.Header>
          <h1>{props.client.uid ? "Edit User" : "New User"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete User</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>user</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
